/* eslint react/no-children-prop: off */
import React from 'react';
import PropTypes from 'prop-types';
import { createBrowserHistory as createHistory } from 'react-history';
import { Router } from 'react-router-dom';

const { RouteService } = window;

class ListenedRouter extends React.Component {
  constructor(props) {
    super(props);

    this.history = createHistory(this.props);
    this.unlisten = this.history.listen(() => {
      RouteService.refresh();
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    const { children } = this.props;

    return (
      <Router
        history={this.history}
        children={children}
      />
    );
  }
}

ListenedRouter.propTypes = {
  children: PropTypes.node,
};

ListenedRouter.defaultProps = {
  children: undefined,
};

export default ListenedRouter;
